<script>
export default {
  props: {
    length: {
      type: Number,
      default: 6,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      valueParts: [],
    }
  },
  computed: {
    value() {
      return this.valueParts.join('').slice(0, this.length)
    },
  },
  watch: {
    valueParts() {
      if (this.value.length === this.length) {
        this.emitInput()
      }
    },
  },
  mounted() {
    if (this.$el.attributes.autofocus) {
      this.focus(0)
    }
  },
  methods: {
    onPaste(event) {
      const clipboardData = event.clipboardData || window.clipboardData
      if (!clipboardData) {
        return
      }
      // IE fix
      event.preventDefault()
      const code =
        clipboardData.getData('Text') || clipboardData.getData('text/plain')
      this.fillCode(code)
    },
    fillCode(code) {
      code = code.trim()
      code = code.slice(0, this.length)
      const parts = code.split('')
      parts.length = this.length
      this.valueParts = parts

      const last = code.length - 1
      setTimeout(() => {
        // cut out extra chars from last input
        this.valueParts[last] =
          this.valueParts[last] && this.valueParts[last].slice(0, 1) // apply just first char
        this.$forceUpdate()
        this.focus(last)
      }, 0)
    },
    handleEnterKey(event) {
      if (event.key === 'Enter') {
        this.$emit('enter')
        event.stopPropagation()
      }
    },
    handleKeyDown(event, index) {
      const key = event.key === 'Unidentified' ? undefined : event.key
      if (!key) {
        event.preventDefault()
      } else if (key === 'Backspace') {
        if (this.valueParts[index]) {
          return (this.valueParts[index] = '')
        }
        this.focus(index - 1)
      } else if (!event.shiftKey && (key === 'ArrowRight' || key === 'Right')) {
        this.focus(index + 1)
      } else if (!event.shiftKey && (key === 'ArrowLeft' || key === 'Left')) {
        this.focus(index - 1)
      } else if (key.length === 1 && this.valueParts[index]) {
        this.valueParts[index] = key
        if (this.valueParts[index + 1]) {
          this.focus(index + 1)
        }
        this.$forceUpdate()
      }
    },
    handleInput(event, index) {
      const value = this.valueParts[index]
      if (value) {
        if (value.length > 1) {
          this.valueParts[index] = value[value.length - 1]
        }
        this.focus(index + 1)
      }
    },
    emitInput() {
      this.$emit('input', this.value)
    },
    focus(index) {
      const inp = this.$refs.wrap.children[index]
      if (inp) {
        inp.focus()
      }
    },
  },
}
</script>

<template>
  <div ref="wrap" autofocus :class="$style.container">
    <input
      v-for="index in length"
      :key="index"
      v-model="valueParts[index - 1]"
      :autofocus="index === 0"
      :disabled="disabled"
      :class="[$style.field]"
      type="text"
      maxlength="1"
      @paste="onPaste"
      @input="handleInput($event, index - 1)"
      @keydown="
        // you can add sequential methods on events !!
        handleEnterKey($event)
        handleKeyDown($event, index - 1)
      "
    />
  </div>
</template>

<style lang="scss" module>
@import '@design';

.field {
  display: inline-block;
  width: 40px;
  height: auto;
  padding: 0.3rem;
  margin: 5px;
  font-size: 200%;
  color: $color-theme-light-offblack;
  text-align: center;
  border-color: #eff0f6;
  border-bottom: 2px solid;
}

.field:focus {
  color: #3f4254;
  outline: 0;
}
</style>
